import * as types from '../actiontypes';

import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

import {FilterEntityConfiguration} from '../../components/Common/Filter/config';

const buildUrl = (entityType, entityFilter) => {
	let endpoint = FilterEntityConfiguration[entityType].endpoint;
	let url = new URL(endpoint, env.getOversightBaseURL(serviceURL, entityFilter.projectId));

	return url.toString();
};

export const getFilterEntities = (key, name, entityType, entityFilter, dataMapping, apiCall = true, data) => {
	return {
		type: types.GET_FILTER_ENTITIES,
		key,
		name,
		entityType,
		dataMapping,
		resolve: true,
		apiCall,
		response: data,
		meta: apiCall
			? {
					api: {
						url: buildUrl(entityType, entityFilter),
						method: 'GET'
					}
			  }
			: null
	};
};

export const getFilterMessageLog = (key, name, entityType, entityFilter, dataMapping, apiCall = true, data) => {
	return {
		type: types.GET_FILTER_MESSAGE_LOG,
		key,
		name,
		entityType,
		dataMapping,
		resolve: true,
		apiCall,
		response: data,
		meta: apiCall
			? {
					api: {
						url: buildUrl(entityType, entityFilter),
						method: 'GET'
					}
			  }
			: null
	};
};
